export default __webpack_public_path__ + "static/media/prototype_crescent.50a174b0.png";